/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CurrencySelector_viewer$ref = any;
type FooterBottomRow_viewer$ref = any;
type LinkColumn_viewer$ref = any;
export type Footer_viewer$ref = any;
export type Footer_viewer = {
    readonly isTradeExperienceEnabled: boolean | null;
    readonly isSellerApplicationEnabled: boolean | null;
    readonly isAboutUsPageEnabled: boolean | null;
    readonly isCareersPageEnabled: boolean | null;
    readonly isPressPageEnabled: boolean | null;
    readonly isQuestionsPageEnabled: boolean | null;
    readonly isSiteMapsEnabled: boolean | null;
    readonly disableFooterSubscribe: boolean | null;
    readonly " $fragmentRefs": CurrencySelector_viewer$ref & LinkColumn_viewer$ref & FooterBottomRow_viewer$ref;
    readonly " $refType": Footer_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "Footer_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isTradeExperienceEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "TRADE_EXPERIENCE"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"TRADE_EXPERIENCE\")"
        },
        {
            "kind": "ScalarField",
            "alias": "isSellerApplicationEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "SELLER_APPLICATION"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"SELLER_APPLICATION\")"
        },
        {
            "kind": "ScalarField",
            "alias": "isAboutUsPageEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "ABOUT_US_PAGE"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"ABOUT_US_PAGE\")"
        },
        {
            "kind": "ScalarField",
            "alias": "isCareersPageEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "CAREERS_PAGE"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"CAREERS_PAGE\")"
        },
        {
            "kind": "ScalarField",
            "alias": "isPressPageEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "PRESS_PAGE"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"PRESS_PAGE\")"
        },
        {
            "kind": "ScalarField",
            "alias": "isQuestionsPageEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "QUESTIONS_PAGE"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"QUESTIONS_PAGE\")"
        },
        {
            "kind": "ScalarField",
            "alias": "isSiteMapsEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "HTML_SITE_MAPS"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"HTML_SITE_MAPS\")"
        },
        {
            "kind": "ScalarField",
            "alias": "disableFooterSubscribe",
            "name": "isEnabled",
            "args": [
                {
                    "kind": "Literal",
                    "name": "key",
                    "value": "disableFooterSubscribe"
                }
            ],
            "storageKey": "isEnabled(key:\"disableFooterSubscribe\")"
        },
        {
            "kind": "FragmentSpread",
            "name": "CurrencySelector_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "LinkColumn_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "FooterBottomRow_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = '65532ed348f20929348cfd3ca03bbedd';
export default node;
